import { put, call, delay, takeEvery } from 'redux-saga/effects';
import { getDepartmentServices } from '../../VTO/index';
import * as actions from './HomePageAction';

export function* getDepartmentServicesData(data) {
    for(let i = 0; i<3; i++) {
        try {
            const response = yield call(
                getDepartmentServices,
                data.params,
            )
            if (response?.status === 200) {
                yield put(actions.getDepartmentServicesDataSuccess(true))
                yield put(actions.getDepartmentServicesResponse(response.data))
            } else {
                yield put(actions.getDepartmentServicesDataSuccess(false))
                console.log("ERROR: " + response?.status );
            }
            break;

        }
        catch (error) {
            yield put(actions.getDepartmentServicesDataSuccess(false))
            console.log("ERROR: " + error);
            break;
        }
    }
}
